/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from '../convo/defs.defs'

const $nsid = 'chat.bsky.group.requestJoin'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  code: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
      (() => ConvoDefs.convoView) as any,
    ),
  ),
  status: /*#__PURE__*/ l.string<{ knownValues: ['joined', 'pending'] }>(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Sends a request to join a group (via join link) to the group owner. Action taken by the prospective group member. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ConvoLocked',
  'FollowRequired',
  'InvalidCode',
  'LinkDisabled',
  'MemberLimitReached',
  'UserKicked',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
